import React from "react";
import { isIntranetPath, isProdEnv } from "lib/routing";
import { isInternalUser } from "lib/entitlements";
import { _t } from "../../../app/i18n/i18n";
import { Tag } from "../PreferenceTags";
import usePreferences from "./usePreferences";

export function AppSettings({ handleClick }) {
  const { preferences, options } = usePreferences();
  const [, ...appPreferences] = options.filter((prefOption) => prefOption.appPreference);

  return (
    <section className="pb-3">
      <h3 className="font-weight-lighter">{_t("App Settings")}</h3>

      {appPreferences.map((preference) => {
        const key = `id${Math.random().toString(16).slice(2)}`;

        return <AppPreference key={key} preference={preference} handleClick={handleClick} preferences={preferences} />;
      })}
    </section>
  );
}

export function AppPreference({ preference, preferences, handleClick }) {
  return (
    <div className={`px-2 ${shldHide(preference)}`}>
      {preference.label && (
        <b>
          {_t(preference.label)}
          <br />
        </b>
      )}
      {_t(preference.description)}
      <br />

      <div className="text-left pt-1 pb-4">
        {preference.tags.map((tag) => (
          <Tag
            key={tag}
            label={tag}
            isActive={preferences[preference.id].includes(tag)}
            onClick={() => handleClick(tag, preference)}
          />
        ))}
      </div>
    </div>
  );
}

const shldHide = (preference) => {
  let isHidden = false;
  if (preference.isNonProduction && isProdEnv) isHidden = true;
  if (preference.isInternalOnly && !isIntranetPath()) isHidden = true;
  if (preference.id === "grp-banner-visibility" && !isInternalUser()) isHidden = true;
  if (preference.id === "grp-redesign") isHidden = true;
  return isHidden ? "d-none" : "";
};
